export const AGENTS_UPDATE_KEY = 'agents';
export const GUARDS_UPDATE_KEY = 'guards';
export const TOOLS_UPDATE_KEY = 'tools';
